import { useMutation } from "@tanstack/react-query";
import { getSubscriptionFlowApiClient } from "@shared/apis/sidekick/api-factories";
import { apiResponseErrorHandler } from "@shared/apis/sidekick/api-error-handler";
import { StartSubscriptionFlowResponse } from "@shared/apis/sidekick/generated";
import { toast } from "@shared/services/toast";

type Props = {
  onSuccess?: (data: StartSubscriptionFlowResponse, params: Params) => void;
};

type Params = {
  email: string;
};

export const useStartEmailSubscriptionFlow = (
  planId: string,
  props?: Props,
) => {
  const { onSuccess } = props || {};
  const api = getSubscriptionFlowApiClient();

  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const response =
        await api.subscriptionFlowControllerStartEmailSubscriptionFlow({
          planId,
          startSubscriptionFlowRequest: {
            email: params.email.toLowerCase(),
          },
        });
      onSuccess?.(response, params);
      return response;
    },
    onError: async (e) => {
      console.error("Error trying to start the email subscription flow.", e);
      const error = await apiResponseErrorHandler(e);
      if (error.status === 409) {
        toast.error(
          "This email is already in use. Please double-check and try again.",
        );
        return;
      }
      toast.error(
        `Error trying to start the subscription. ${error.errors[0]}`,
      );
    },
  });

  return mutation;
};
